module.exports = __webpack_public_path__ + "img/tg.ed5ec57b.svg";